<p-card class="wo-card" [ngClass]="{'multiday': workOrder.isMultiday, 'grayOverlay': shouldDisableWODrag}" (click)="dblclickHandler()">
  @if (workOrder) {
    <p-header class="container">
      <div class="wo-header row">
        <div class="zip-code col-6 no-gutter"
          [style.background]="getZipBackgroundColor()"
          [style.color]="getZipColor()">
          {{workOrder.address?.zip}}
        </div>
        <div class="status col-6 no-gutters" (mouseenter)="datePanel02.toggle($event)" (mouseleave)="datePanel02.toggle($event)"
          [style.background]="getPriorityBackgroundColor()"
          [style.color]="getPriorityColor()">
          {{workOrder.mostUrgentPriorityLevel?.status}}
          <p-popover #datePanel02 [appendTo]="'body'">
            <div>
              {{workOrder.mostUrgentPriorityLevel?.status}}
            </div>
            @if (workOrder.completionStatus != 'Completed' && workOrder.completionStatus !='Unable to be Completed') {
              <div>
                @for (task of unscheduledTasks; track task) {
                  <span>
                    @if (!task.wellnessTask.isGoBack) {
                      <div>
                        {{getDueDateDisplay(task.wellnessTask)}}
                      </div>
                    }
                    @if (task.wellnessTask.isGoBack) {
                      <div>
                        GO BACK
                      </div>
                    }
                  </span>
                }
              </div>
            }
          </p-popover>
        </div>
      </div>
    </p-header>
  }

  <div class="customer-name">
    <a [routerLink]="" (click)="navigateToWorkOrder()" class="blue-link">{{workOrder.quoteNumber}}</a> @if (workOrder.isMultiday) {
    <span>- Multiday</span>
    }<br>
    {{customCustomerService.getCustomerFullName(workOrder.customer)}} @if (showMap) {
    <i class="fa fa-map-marked-alt" (click)="openMap()"></i>
    }<br />
    @if (hasCompanyWideNotes) {
      <i class="fa fa-sticky-note" (click)="op.toggle($event)"></i>
    }
    <p-popover #op>
      <app-customer-comment-view-only [customer]="workOrder.customer"></app-customer-comment-view-only>
    </p-popover>
  </div>

  <div class="equipment-type">
    {{ equipmentTypeDisplay }}
  </div>

  <div class="toggle-more-information">
    <div #container class="left" (click)="taskPanel.toggle($event)">
      {{scheduledTasksTotal}}/{{workOrder.workOrderWellnessTasks.length}}
      <p-popover #taskPanel appendTo="body">
        <div class="center bold">Wellness Tasks</div>
        @for (woWellnessTask of workOrder.workOrderWellnessTasks; track woWellnessTask) {
          <div>
            <span class="left">{{woWellnessTask.wellnessTask.name}}
              @if (woWellnessTask.wellnessTask.scheduleDateFrom) {
                <i class="pi pi-star middle" [pTooltip]="woWellnessTask.wellnessTask.scheduleDateFrom | date: 'shortDate'"
                ></i>
              }
            </span>
          </div>
        }
      </p-popover>
    </div>
    @if (isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
          +
        </span>
      </div>
    }
    @if (!isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
          -
        </span>
      </div>
    }
    <div [ngbCollapse]="isCollapsed" class="more-information">
      <div [id]="'woTaskList-' + workOrder.id" cdkDropList [cdkDropListData]="unscheduledTasks" [cdkDropListDisabled]="!canDrag"
        [cdkDropListConnectedTo]="dragAndDropService.bucketWOListIds" cdkDropListSortingDisabled="true">
        @for (woWellnessTask of unscheduledTasks; track woWellnessTask) {
          <div class="inner-card" cdkDrag
            (cdkDragStarted)="dragStart(woWellnessTask, $event)" (cdkDragEnded)="taskDragEnd()"
            [cdkDragDisabled]="shouldDisableTaskDrag(woWellnessTask.wellnessTask)">
            <app-task-card [task]="woWellnessTask.wellnessTask" [isDisabled]="shouldDisableTaskDrag(woWellnessTask.wellnessTask)" [showPrice]="!workOrder.hidePrice || canSeeHiddenPrice"></app-task-card>
          </div>
        }
      </div>
    </div>
  </div>

  @if (workOrder) {
    <div class="card-footer">
      @if (workOrder.completionStatus) {
        <span>{{workOrder.completionStatus}}</span>
      }
      <hr style="padding: 0px; margin: 0px;"/>
      <span>@if (!workOrder.hidePrice || canSeeHiddenPrice) {
        <span>{{priceSummary | currency}} <i class="pi pi-circle-on" style="font-size: .5em;"></i></span>
      } {{hoursSummary | number: '1.0-2'}} {{unit}}</span>
    </div>
  }
</p-card>
